export default {
  namespace: 'invoices',
  en: {
    title: 'Invoices',
    common: {
      invoice: 'Invoice',
      invoices: 'Invoices',
      number: 'Number',
      status: 'Status',
      date: 'Date',
      days: 'Days',
      expireDate: 'Expire date',
      amount: 'Amount',
      totalAmount: 'Total',
      outstandingAmount: 'Outstanding',
      description: 'Description',
      paid: 'Paid',
      unpaid: 'Unpaid',
      processing: 'Processing',
      payments: 'Payments',
      group: 'Group',
      name: 'Name',
      from: 'From',
      to: 'To',
      price: 'Price',
      total: 'Total',
      details: 'Details',
      paymentTerm: 'Payment term',
      paymentMethod: 'Payment method',
      directDebit: 'Direct debit',
      paymentReference: 'Payment reference',
      paymentStatus: 'Payment status',
      totalsOverview: 'Totals overview',
      subtotal: 'Subtotal',
      vat: 'VAT',
      customerDetails: 'Customer details',
      address: 'Address',
      country: 'Country',
      vatNumber: 'VAT number',
      reference: 'Reference',
      downloadInvoice: 'Download invoice',
      saveAs: 'Save as {{type}}',
      term: 'Term',
      pay: 'Pay',
      payInvoice: 'Pay invoice',
      downloadNotAvailable: 'Download not available (yet)',
      quantity: 'Quantity',
    },
    payment: {
      successful: {
        title: 'Payment successful!',
        message: 'The payment was received. It might take a while for the invoice to be updated.',
      },
      failed: {
        title: 'Payment failed',
        message: 'The payment was not successful.',
      },
      back: 'Back to invoice',
    },
  },
  nl: {
    title: 'Invoices',
    common: {
      invoice: 'Factuur',
      invoices: 'Facturen',
      number: 'Nummer',
      status: 'Status',
      date: 'Datum',
      days: 'Dagen',
      expireDate: 'Vervaldatum',
      amount: 'Bedrag',
      totalAmount: 'Totaal',
      outstandingAmount: 'Openstaand',
      description: 'Beschrijving',
      paid: 'Betaald',
      unpaid: 'Onbetaald',
      processing: 'In behandeling',
      payments: 'Betalingen',
      group: 'Groep',
      name: 'Naam',
      from: 'Van',
      to: 'Tot',
      price: 'Prijs',
      total: 'Totaal',
      details: 'Details',
      paymentTerm: 'Betalingstermijn',
      paymentMethod: 'Betaalmethode',
      directDebit: 'Automatische incasso',
      paymentReference: 'Betalingsreferentie',
      paymentStatus: 'Betalingsstatus',
      totalsOverview: 'Totaaloverzicht',
      subtotal: 'Subtotaal',
      vat: 'Btw',
      customerDetails: 'Klantgegevens',
      address: 'Adres',
      country: 'Land',
      vatNumber: 'Btw-nummer',
      reference: 'Referentie',
      downloadInvoice: 'Factuur downloaden',
      saveAs: 'Opslaan als {{type}}',
      term: 'Termijn',
      pay: 'Betalen',
      payInvoice: 'Factuur betalen',
      downloadNotAvailable: 'Download (nog) niet beschikbaar',
      quantity: 'Aantal',
    },
    payment: {
      successful: {
        title: 'Betaling geslaagd!',
        message:
          'De betaling is ontvangen. Het kan even duren voordat de status van de factuur is bijgewerkt.',
      },
      failed: {
        title: 'Betaling mislukt',
        message: 'De betaling is niet succesvol afgerond.',
      },
      back: 'Terug naar factuur',
    },
  },
};
